export function normalizeApiError(error) {
  const data = error?.response?.data;
  const messages = [];
  if (error?.response?.status === 409) {
    messages.push("Der Datensatz wurde inzwischen geändert. Bitte laden Sie die Daten neu und prüfen Sie die Aktion erneut.");
  }
  const message = data?.messageDe || data?.Message || data?.message;
  if (typeof message === "string") messages.push(message);
  const validation = data?.ModelState || data?.modelState || data?.errors;
  if (validation && typeof validation === "object") {
    Object.values(validation).forEach((entries) => {
      (Array.isArray(entries) ? entries : [entries]).forEach((entry) => {
        if (typeof entry === "string") messages.push(entry);
      });
    });
  }
  if (!messages.length && typeof data === "string" && data.trim()) messages.push(data);
  return [...new Set(messages)].join(" ") || error?.message || "Die Daten konnten nicht verarbeitet werden.";
}
